import CTASection from "../components/CTA";
import Footer from "../components/Footer";
import Header from "../components/Header";
import WhyTrustUs from "../components/Homesections/lastsection";
import ObsGynaeSection from "../components/ObsGynaeSection";
import Obsp from "../components/obsp";
import { Helmet } from "react-helmet";
import Banner from "../components/layout/Banner";

const Obs = () => {
  return (
    <>
      <Helmet>
        <title>
          OBS & GYNAE Services - Dr Vibha Clinic | Obstetrics & Gynecology
          Specialist
        </title>
        <meta
          name="description"
          content="Expert obstetrics and gynecology services at Dr Vibha Clinic. We provide comprehensive care for pregnancy, women's health, menstrual issues, PCOS, and reproductive health."
        />
        <meta
          name="keywords"
          content="OBS & GYNAE, obstetrics, gynecology, pregnancy care, women's health, PCOS treatment, gynecologist, Dr Meenu Clinic"
        />
        <meta name="author" content="Dr Vibha Clinic" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="OBS & GYNAE Services - Dr Meenu’s Clinic"
        />
        <meta
          property="og:description"
          content="Comprehensive obstetrics and gynecology care including pregnancy care, PCOS treatment, and women's reproductive health services."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      {<Header />}
        <Banner
        title="OBS & GYNAE"
        subtitle="Compassionate Care for Every Stage of a Woman’s Life"
        image="https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg/1280px-A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg"
      />
      {<ObsGynaeSection />}
      {<Obsp />}
      {<WhyTrustUs />}
      <CTASection
        title="Take One Step Closer To"
        highlight="Parenthood"
        description="Every journey to becoming a parent is unique. At Dr vibha` Clinic, we combine care, expertise, and technology to give you the best chance of success."
        buttonText="BOOK YOUR APPOINTMENT"
        buttonLink="/contact-us"
      />
      {<Footer />}
    </>
  );
};

export default Obs;
